import React from 'react';
import classNames from 'classnames';

import BreadCrumbs from 'components/Common/BreadCrumbs/BreadCrumbs';
import ProductBackLink from 'components/ProductPageV2/ProductBackLink/ProductBackLink';
import { newProductBreadCrumb } from 'services/data';
import { PartialRecord } from 'types/Base';
import {
  ProductAttributeType,
  ProductBreadcrumbType,
} from 'types/ProductPageV2/Products';

import styles from './ProductHeader.module.scss';

type Props = {
  classes?: { container: string };
  breadcrumbs: ProductBreadcrumbType[];
  productAttributes: PartialRecord<
    'libelle' | 'nomModele' | 'couleur',
    ProductAttributeType
  >;
};

export default function ProductHeader({
  classes,
  breadcrumbs,
  productAttributes,
}: Props): JSX.Element {
  return (
    <div className={classNames(styles.container, classes?.container)}>
      <BreadCrumbs
        breadCrumbsHierarchies={[
          ...breadcrumbs,
          newProductBreadCrumb(
            '',
            [
              productAttributes.libelle?.Value || '',
              productAttributes.nomModele?.Value.toUpperCase() || '',
              productAttributes.couleur?.Value.toUpperCase() || '',
            ]
              .filter(Boolean)
              .join(' ')
          ),
        ]}
        productPage
        className={styles.breadcrumbs}
      />
      <ProductBackLink
        breadcrumb={breadcrumbs}
        classes={{ container: styles.backLinkContainer }}
      />
    </div>
  );
}
